import { runAnalytics } from "./runAnalytics";
import { sendStapePurchase, resolveCapturedStapeAttribution } from "./stapePurchase";
import { runWithConsent } from "./consent";
const DEFAULT_TIMEOUT_MS = 300;
const buildDedupeKey = ({ type, paywall, value, clientReferenceId, extraKey }) => {
  const base = [
    "purchase",
    type || "",
    paywall || "",
    value != null ? String(value) : "",
    clientReferenceId || "",
    extraKey || "",
  ].join("|");
  return base;
};

const markIfNew = (dedupeKey) => {
  try {
    const storageKey = `gtm_purchase_${dedupeKey}`;
    if (sessionStorage.getItem(storageKey)) {
      return false;
    }
    sessionStorage.setItem(storageKey, "1");
    return true;
  } catch (_) {
    return true;
  }
};

export const pushPurchaseEvent = async ({
  clientReferenceId,
  paywall,
  value,
  type,
  extraKey,
  transactionId,
  paymentStatus,
  acquisitionCampaign,
  acquisitionContext,
  productKey,
  flowVersion,
  funnel,
  step,
  currency,
  product,
  timeoutMs = DEFAULT_TIMEOUT_MS,
} = {}) => {
  if (typeof window === "undefined") return Promise.resolve();

  try {
    acquisitionContext = resolveCapturedStapeAttribution(acquisitionContext);
    const stapeInput = { type, transactionId, paymentStatus, value, currency, acquisitionCampaign, acquisitionContext };
    // Delayed geo must not hold either ordinary GTM or navigation. The ready
    // path queues immediately, including the existing redirect marker.
    if (acquisitionContext?.then) {
      runAnalytics(() => Promise.resolve(acquisitionContext).then(context =>
        sendStapePurchase({ ...stapeInput, acquisitionContext: context })
      ));
    } else runAnalytics(() => sendStapePurchase(stapeInput));
    return await runWithConsent("any", () => {
      const dedupeKey = buildDedupeKey({ type, paywall, value, clientReferenceId, extraKey: transactionId || extraKey });
      const isNew = markIfNew(dedupeKey);
      if (!isNew) return Promise.resolve();

      const dl = (window.dataLayer = window.dataLayer || []);

      return new Promise((resolve) => {
        const timer = setTimeout(resolve, timeoutMs);

        const payload = {
          event: "purchase",
          client_reference_id: clientReferenceId,
          paywall,
          value: value != null ? Number(value) : undefined,
          type,
          ...(currency ? { currency: String(currency).toUpperCase() } : {}),
          ...(product ? { product } : {}),
          ...(transactionId ? { transaction_id: transactionId } : {}),
          ...(productKey ? { product_key: productKey } : {}),
          ...(flowVersion ? { flow_version: flowVersion } : {}),
          ...(funnel ? { funnel } : {}),
          ...(step ? { step } : {}),
          eventCallback: () => {
            clearTimeout(timer);
            resolve();
          },
        };

        try { dl.push(payload); } catch (_) { clearTimeout(timer); resolve(); }
      });
    });
  } catch (_) { /* Tracking cannot turn a successful charge into a retry. */ }
};
